import React, { PropsWithChildren, memo } from "react";

export const ListHeading: React.FC<PropsWithChildren> = memo(({ children }) => (
  <div className="w-full bg-gray-100 py-4 px-8 text-sm font-bold text-gray-500">
    {children}
  </div>
));
